import React, { memo, useState } from 'react'
import { useMediaQuery, IconButton } from '@mui/material'
import List from '@mui/material/List'
import MenuIcon from '@mui/icons-material/AppsOutlined'
import { LogoutProvider } from '../LogOut/context'
import { AppBarContainer, Toolbar, LogoGlobo, ContainerLogoGlobo, PalcoName, Separator, UserContainer } from './styles'
import Menu from './Menu'
import UserItem from './Menu/UserItem'

function AppBar() {
  const isSmallScreen = useMediaQuery('(max-width:900px)')
  const isMobile = useMediaQuery('(max-width:600px)')
  const date = new Date().getMonth() + 1

  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <LogoutProvider>
      <AppBarContainer position="fixed" $menuOpen={menuOpen} $date={date}>
        <Toolbar>
          <ContainerLogoGlobo>
            <LogoGlobo $isSmall={false} />
            {isMobile && <PalcoName $isSmall={false}>Palco</PalcoName>}
          </ContainerLogoGlobo>

          {!isMobile && (
            <>
              <Separator />
              <PalcoName $isSmall={isSmallScreen}>Palco</PalcoName>
            </>
          )}
        </Toolbar>

        {isMobile ? (
          <>
            <IconButton color="inherit" edge="end" onClick={() => setMenuOpen(true)}>
              <MenuIcon sx={{ marginRight: '15px' }} />
            </IconButton>

            <Menu open={menuOpen} onClose={() => setMenuOpen(false)} variant="temporary" />
          </>
        ) : (
          <UserContainer>
            <List>
              <UserItem />
            </List>
            <Menu variant="permanent" open />
          </UserContainer>
        )}
      </AppBarContainer>
    </LogoutProvider>
  )
}

export default memo(AppBar)
